interface RotatingSegmentTitlesResponse {
  updatedOn: number;
  frequency: number;
  data: Record<string, unknown>;
}

export interface ParsedRotatingSegmentTitles {
  updatedOn: number;
  frequency: number;
  titleData: Record<string, unknown>;
}

export const parseRotatingSegmentTitles = (response: RotatingSegmentTitlesResponse): ParsedRotatingSegmentTitles => {
  return {
    updatedOn: response.updatedOn,
    frequency: response.frequency,
    titleData: response.data,
  };
};
